import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-down",
  "use": "chevron-down-usage",
  "viewBox": "0 0 33 34",
  "content": "<symbol viewBox=\"0 0 33 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron-down\">\r\n<path d=\"M7.20117 13.2903C7.73243 12.759 8.59376 12.759 9.12501 13.2903L16.3253 20.4905L23.5255 13.2903C24.0568 12.759 24.9181 12.759 25.4493 13.2903C25.9806 13.8215 25.9806 14.6829 25.4493 15.2141L17.2872 23.3763C16.7559 23.9075 15.8946 23.9075 15.3633 23.3763L7.20117 15.2141C6.66992 14.6829 6.66992 13.8215 7.20117 13.2903Z\" fill=\"#404040\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol